@if (productData.activeConsole) {
<section class="section-1 text-bg-gray-20">
    @let heading = { headingText: 'PRODUCT-PAGE_' + productData['product-name']
    | generateKey : productData?.activeConsole?.['console-name'] :
    'SECTION-1_HEADING_TEXT' | keyify | translate, description: 'PRODUCT-PAGE_'
    + productData['product-name'] | generateKey :
    productData?.activeConsole?.['console-name'] : 'SECTION-1_DESCRIPTION_TEXT'
    | keyify | translate }; @if (heading.headingText || heading.description) {
    <div class="container text-center py-4">
        <div class="col-12 col-xl-10 offset-xl-1">
            <h2 [innerHTML]="heading.headingText" class="text-blue-300"></h2>
            <div [innerHTML]="heading.description"></div>
        </div>
    </div>
    }
    <div class="container py-4 mb-4">
        <div class="row g-0 justify-content-center">
            <div class="col-12 col-sm-10 col-md-12 col-xl-10">
                <div class="row justify-content-center">
                    <div
                        class="col-12 col-sm-10 col-md-8 col-lg-5 mb-3 mb-md-4 mb-lg-0"
                    >
                        <img
                            [alt]="
                                productData.activeConsole.consoleImage
                                    .webDisplayName
                            "
                            [src]="
                                productData.activeConsole.consoleImage.cdnUrl
                            "
                            class="img-fluid"
                        />
                    </div>
                    <div class="col-12 col-md-10 col-lg-7">
                        <div class="console-info mb-4">
                            <h4
                                [innerHTML]="
                                    productData.activeConsole.webDisplayName
                                "
                                class="text-blue-300 mb-1"
                            ></h4>
                            <p
                                [innerHTML]="
                                    'PRODUCT-PAGE_' +
                                        productData['product-name']
                                        | generateKey
                                            : productData.activeConsole[
                                                  'console-name'
                                              ]
                                            : 'SECTION-1_CONSOLE_SUB-HEADING_TEXT'
                                        | keyify
                                        | translate
                                "
                                class="lead mb-1"
                            ></p>
                            <p
                                [innerHTML]="
                                    'PRODUCT-PAGE_' +
                                        productData['product-name']
                                        | generateKey
                                            : productData.activeConsole[
                                                  'console-name'
                                              ]
                                            : 'SECTION-1_CONSOLE_DESCRIPTION_TEXT'
                                        | keyify
                                        | translate
                                "
                                class="m-0"
                            ></p>
                        </div>
                        @if (productData.activeConsole.features &&
                        productData.activeConsole.features.length > 0) {
                        <div class="console-features nav mb-2">
                            @for (feature of productData.activeConsole.features;
                            track feature; let first = $first) {
                            <div
                                (click)="onFeatureClick(feature)"
                                (keydown.enter)="onFeatureClick(feature)"
                                [ngClass]="{
                                                active:
                                                    feature === currentFeature,
                                            }"
                                class="nav-link mb-2 mb-xl-0"
                                role="button"
                            >
                                <img
                                    [alt]="feature?.['feature-title']"
                                    [src]="feature?.['feature-icon']"
                                    class="feature-icon"
                                    [tabIndex]="0"
                                />
                            </div>
                            }
                        </div>
                        <div class="feature-tooltips">
                            <div class="feature-tooltip">
                                <p
                                    [innerHTML]="currentFeature?.['feature-title']"
                                    class="lead mb-1 mb-lg-0"
                                ></p>
                                <div
                                    [innerHTML]="currentFeature?.['feature-description']  | translate : 'markdown'"
                                    class="m-0"
                                ></div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
}
